<div mat-dialog-content>
  <div class="closed-dialog">
    <span class="material-icons md-36 cursor-pointer" (click)="closeDialog()">close</span>
  </div>
  <ng-container [ngTemplateOutlet]="data.template" [ngTemplateOutletContext]="data.context"></ng-container>
</div>
